<div class="lifeislife-contact">
  <span class="label">
   {{ label$ | async }}
  </span>
</div>
